import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';

import { AppConstants } from '@apps/app.constants';

@Injectable({
    providedIn: 'root'
})
export class JobStatsApiService {
    private segmentRoot: string;
    private resourceUrl = '/hist/netbackup/jobstats';

    constructor(private http: HttpClient) {
        this.segmentRoot = AppConstants.Configuration.apiUrlHist;
    }

    getJobStats(qs: string): Observable<JobStatsApi> {
        return this.http.get<JobStatsApi>(`${this.segmentRoot}${this.resourceUrl}${qs}`);
    }
}

export interface JobStatsApi {
    success: number;
    partial: number;
    failed: number;
    total: number;
}
